import { useQuery } from "react-query";
import { magento } from "../../client/getClient";
export const useRegions = (countryId, enabled = true) => {
    var _a, _b;
    const { data, isLoading } = useQuery(["getCountry", countryId], () => magento.getCountry(countryId), {
        enabled,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
    const regions = ((_b = (_a = data === null || data === void 0 ? void 0 : data.country) === null || _a === void 0 ? void 0 : _a.available_regions) !== null && _b !== void 0 ? _b : []).filter((region) => Boolean((region === null || region === void 0 ? void 0 : region.id) && (region === null || region === void 0 ? void 0 : region.code) && (region === null || region === void 0 ? void 0 : region.name)));
    return {
        regions,
        isLoadingRegions: isLoading,
    };
};
//# sourceMappingURL=useRegions.js.map